import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';

// Notifications live in the sidebar bell (src/layout/menu.js → NotificationBell).
// The header keeps only the product title so there is a single notification bell.
class Header extends Component {

  render()
    {
      return(
          <header>
          <Row className='header-container'>
            <Col sm={12} xs={12} className="header-title">
              SKOKIE
            </Col>
            </Row>
          </header>
      );
    }

}

export default Header;
